import {
    initialDeviceDetailsState, initialNoleggioInScadenzaTableData,
    initialNoleggioTableData,
    initialRestituzioniDetails,
    initialRestituzioniDetailsTableData,
    initialRestituzioniTableData,
    initialTabsCountState,
    initialVenditaTableData
} from "./helper";
import * as actionTypes from "./actionTypes";
import {updateObject} from "../../shared/utils/updateObject";

const initialState = {
    venditaTableData: initialVenditaTableData,
    noleggioTableData: initialNoleggioTableData,
    noleggioInScadenzaTableData: initialNoleggioInScadenzaTableData,
    restituzioniTableData: initialRestituzioniTableData,
    tabsCount: initialTabsCountState,
    deviceDetails: initialDeviceDetailsState,
    wrenchLoading: false,
    restituzioniDetails: initialRestituzioniDetails,
    restituzioniDetailsTableData: initialRestituzioniDetailsTableData,
    downloadCsvLoading: false,
}

const setVenditaTableData = (state, action) => {
    return updateObject(state, {
        venditaTableData: updateObject(state.venditaTableData,
            {[action.key]: action.value})
    })
}

const setNoleggioTableData = (state, action) => {
    return updateObject(state, {
        noleggioTableData: updateObject(state.noleggioTableData,
            {[action.key]: action.value})
    })
}

const setNoleggioInScadenzaTableData = (state, action) => {
    return updateObject(state, {
        noleggioInScadenzaTableData: updateObject(
            state.noleggioInScadenzaTableData,
            {
                [action.key]: action.value,
            }
        ),
    });
};
const setRestituzioniTableData = (state, action) => {
    return updateObject(state, {
        restituzioniTableData: updateObject(state.restituzioniTableData,
            {[action.key]: action.value})
    })
}

const setDeviceDetails = (state, action) => {
    return updateObject(state, {
        deviceDetails: updateObject(state.deviceDetails,
            {[action.key]: action.value})
    })
}

const setWrenchDetailsDevice = (state, action) => {
    let devices = [...state[action.deviceType].data.data];
    let tmpDevices = [];
    devices.forEach(device => {
        let tmpWrenchDetails = action.wrenchDetails.find(d => d.objectId === device.imei);
        let tmpS = {...device, ...tmpWrenchDetails};
        tmpDevices.push(tmpS);
    });
    let tmpObj = {
        ...state[action.deviceType],
        data: {data: tmpDevices, totalElements: state[action.deviceType].data.totalElements},
        wrenchLoaded: true
    };
    return updateObject(state, {[action.deviceType]: tmpObj});
}

const setWrenchLoadingDevice = (state, action) => {
    return updateObject(state, {wrenchLoading: action.value});
}

const setSimGroupCount = (state, action) => {
    return updateObject(state, {
        tabsCount: updateObject(state.tabsCount, {
            [action.key]: updateObject(state.tabsCount[action.key], {count: action.payload})
        })
    })
}

const setSimGroupCountLoading = (state, action) => {
    return updateObject(state, {
        tabsCount: updateObject(state.tabsCount, {
            [action.key]: updateObject(state.tabsCount[action.key], {loading: action.payload})
        })
    })
}

const setRestituzioniDetailsAndLoading = (state, action) => {
    return updateObject(state, {
        restituzioniDetails: updateObject(state.restituzioniDetails,
            {[action.key]: action.value})
    })
}

const setRestituzioniDetailsTableData = (state, action) => {
    return updateObject(state, {
        restituzioniDetailsTableData: updateObject(state.restituzioniDetailsTableData,
            {[action.key]: action.value})
    })
}

const setDownloadCsvLoading = (state, action) => {
    return updateObject(state, {downloadCsvLoading: action.payload})
}

const devicesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_VENDITA_TABLE:
            return setVenditaTableData(state, action);
        case actionTypes.GET_NOLEGGIO_TABLE:
            return setNoleggioTableData(state, action);
        case actionTypes.GET_RESTITUZIONI_TABLE:
            return setRestituzioniTableData(state, action);
        case actionTypes.GET_DEVICE_DETAILS:
            return setDeviceDetails(state, action);
        case actionTypes.SET_WRENCH_DETAILS_DEVICE_V2:
            return setWrenchDetailsDevice(state, action);
        case actionTypes.SET_WRENCH_LOADING_DEVICES_V2:
            return setWrenchLoadingDevice(state, action);
        case actionTypes.SET_DEVICE_TAB_COUNT:
            return setSimGroupCount(state, action)
        case actionTypes.SET_DEVICE_TAB_COUNT_LOADING:
            return setSimGroupCountLoading(state, action)
        case actionTypes.GET_RESTITUZIONI_DETAILS_AND_LOADING:
            return setRestituzioniDetailsAndLoading(state, action)
        case actionTypes.GET_RESTITUZIONI_DETAILS_TABLE:
            return setRestituzioniDetailsTableData(state, action)
        case actionTypes.GET_NOLEGGIO_IN_SCADENZA_TABLE:
            return setNoleggioInScadenzaTableData(state, action);
            case actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING:
            return setDownloadCsvLoading(state, action)
        default:
            return state;
    }
}

export default devicesReducer;
